import Input from "../../../../../components/input/Input";
import { getPublicMapLink } from "../../../../../services/GlobalRoles/getPublicMapLink";
import { useWebsite } from "../Context/WebSiteContext";


import React, { useEffect, useState } from "react";

const MapSite = ({ control, setValue, errors, templateId, enterprise_id, onMapLink, form}) => {
  const { formData, updateFormData } = useWebsite();
  const [mapLink, setMapLink] = useState("");

  useEffect(() => {
    let didRequest = false;
    async function fetchMapLink() {
      if (!enterprise_id || didRequest) return;
      didRequest = true;
      const sendData = {
        empId: enterprise_id,
        typeMap: "map",
      };
      const protocol = window.location.protocol;
      const baseUrl = window.location.host;
      const res = await getPublicMapLink(sendData);
      const link = `${protocol}//${baseUrl}/publicMap/${res.success}`;
      setMapLink(link);
      form.setValue("mapLink", link, { shouldDirty: true });
      if (onMapLink) onMapLink(link);
      if (updateFormData) updateFormData({ map: [link] });
    }
    fetchMapLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Executa apenas uma vez ao montar

  return (
    <div>
      <Input
        label="Link do mapa público"
        value={mapLink}
        disabled
        control={form.control}
        name="mapLink"
        type="text"
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default MapSite;
